import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-store-select',
  templateUrl: './store-select.component.html',
  styleUrls: ['./store-select.component.css']
})
export class StoreSelectComponent implements OnInit {

  model = { 'store_id': '0' };

  store_list = [];
  Success_Msg; Error_Msg; Store_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<StoreSelectComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Store_Msg').subscribe((res: string) => {
      this.Store_Msg = res;
    });

  }
  ngOnInit() {

    if (this.dialog_data != null) {
      this.store_list = this.dialog_data;
    }

    else {
      let user_id = this.applicationConstants.user_info['user_id'];
      //get store list:
      let query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
        " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1' AND" +
        " `branch_auth`.`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id +
        "' AND `branch_auth`.`user_id` = '" + user_id + "'";

      let obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.store_list = data.data['list'];
        });
    }
  }

  save_store() {
    if (this.model['store_id'] == '0')
      alert(this.Store_Msg);

    else {
      this.applicationConstants.user_branch_info.user_store_id = this.model['store_id'];

      this.store_list.forEach(element => {
        if (element.store_id == this.model['store_id']) {
          this.applicationConstants.user_branch_info.user_store_name = element.store_name;
          this.applicationConstants.user_branch_info.user_store_name_en = element.store_name_en;
        }
      });

      //alert(this.Success_Msg);
      this.dialog_data = { 'op_type': 'success' };
      this.dialogRef.close(this.dialog_data);
    }
  }

  cancel() {
    if (this.applicationConstants.user_branch_info.user_branch_id == '0')
      alert(this.Store_Msg);

    else {
      this.dialog_data = { 'op_type': 'cancel' };
      this.dialogRef.close(this.dialog_data);
    }
  }

}
